import moment from 'moment';

const thirtyDaysInMillis = 30 * 86400000;

const defaultDateFormat = 'MM/DD/YYYY';

// this will display the date in the following format: "07/30/2024 03:00 pm" (lower case meridian)
const defaultDateTimeFormat = `${defaultDateFormat}  hh:mm a`;

// this will display the date in the following format: "07/30/2024 03:00 PM" (upper case meridian)
const defaultDateTimeUppercaseFormat = defaultDateTimeFormat.replace('a', 'A');

export const toLocalDateString = (date: any): string => {
    if (date?.date) {
        return moment(date.date).utc().format(defaultDateFormat);
    } else if (date) {
        return moment(date).utc().format(defaultDateFormat);
    }
    return '';
};

export const toLocalDateTimeString = (
    date: any,
    isAMPMUppercase: boolean = false
): string => {
    if (date?.date) {
        return moment(date.date).format(
            isAMPMUppercase
                ? defaultDateTimeUppercaseFormat
                : defaultDateTimeFormat
        );
    } else if (date) {
        return moment(date).format(
            isAMPMUppercase
                ? defaultDateTimeUppercaseFormat
                : defaultDateTimeFormat
        );
    }
    return '';
};

export const isDateExpiredFromCurrentDate = (date: any): boolean => {
    return moment().isAfter(date);
};

export const convertDateToMonthYearDate = (date: any): string | null => {
    if (!date) {
        return null;
    }
    try {
        const convertedDateCheck = new Date(date);
        if (isNaN(convertedDateCheck.getMonth())) {
            return null;
        }
        const convertedDate = moment(date).utc();
        if (convertedDate.format('MMMM') === 'Invalid date') {
            return null;
        }
        return `${convertedDate.format('MMMM')} ${convertedDate.format(
            'YYYY'
        )}`;
    } catch (error) {
        return null;
    }
};

export const getDateStatusOf2Dates = (_: any, date2: any): string => {
    if (!date2) {
        return 'Active';
    }
    try {
        const milliEnd = new Date(date2).getTime();
        const milliCurrent = new Date().getTime();
        const timeRemaining = milliEnd - milliCurrent;
        if (timeRemaining <= 0) {
            return 'Expired';
        }
        if (timeRemaining >= thirtyDaysInMillis) {
            return 'Active';
        }
        if (timeRemaining > 0 && timeRemaining <= thirtyDaysInMillis) {
            return 'Expires Soon';
        }
        return 'Invalid';
    } catch (err) {
        return 'Inactive';
    }
};

export const convertDateToMonthDayYear = (date: any): string => {
    if (!date) {
        return '';
    }
    try {
        const d = moment(date).utc();
        return `${d.format('MMMM')} ${d.format('D')} ${d.format('YYYY')}`;
    } catch (err) {
        return '';
    }
};

export const defaultDate = (): string => {
    return moment().format('YYYY-MM-DD');
};

export const stringToLocalDate = (date: any): string => {
    if (date?.date) {
        return moment(date.date).utc().format('YYYY-MM-DD');
    } else if (date) {
        return moment(date).utc().format('YYYY-MM-DD');
    }
    return '';
};

export const commaSeparatedLocalDate = (date: any): string => {
    if (date?.date) {
        return moment(date.date).utc().format('ll');
    } else if (date) {
        return moment(date).utc().format('ll');
    }
    return '';
};

export const stringToDateTime = (date: any): string => {
    if (date) {
        return moment(date).utc().format('MM-DD-YYYY HH:MM');
    }
    return '';
};

export const stringToUTCDate = (date: string): string | null => {
    if (date) {
        return new Date(date).toISOString();
    }
    return null;
};

export const toHoursAndMinutes = (totalMinutes?: number): string => {
    if (!totalMinutes) return '';
    const hours = totalMinutes / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    let hoursString = '';
    let minutesString = '';

    if (rhours === 1) {
        hoursString = `${rhours.toString()} hr`;
    } else if (rhours > 1) {
        hoursString = `${rhours.toString()} hrs`;
    }

    if (rhours && rminutes) {
        minutesString += ' and ';
    }

    if (rminutes === 1) {
        minutesString += `${rminutes.toString()} min`;
    } else if (rminutes > 1) {
        minutesString += `${rminutes.toString()} mins `;
    }

    return hoursString + minutesString;
};
